

var dispatcher = require("../dispatcher");

module.exports = {
    addKamgar:function(KamgarInfo){
        dispatcher.dispatch({
            KamgarInfo:KamgarInfo,
            type:"KamgarInfo:addKamgar"
        })
    },
    insertKamgar:function(KamgarInfo){
        dispatcher.dispatch({
            KamgarInfo:KamgarInfo,
            type:"KamgarInfo:insertKamgar"
        })
    },
    addMukadam:function(KamgarInfo){
        dispatcher.dispatch({
            KamgarInfo:KamgarInfo,
            type:"KamgarInfo:addMukadam"
        })
    },
    CheckMukadamInfo:function(KamgarInfo){
        dispatcher.dispatch({
            KamgarInfo:KamgarInfo,
            type:"KamgarInfo:CheckMukadamInfo"
        })
    },
    UpdateMukadam:function(KamgarInfo){
        dispatcher.dispatch({
            KamgarInfo:KamgarInfo,
            type:"KamgarInfo:UpdateMukadam"
        })
    },
    UpdateKamgar:function(KamgarInfo){
        dispatcher.dispatch({
            KamgarInfo:KamgarInfo,
            type:"KamgarInfo:UpdateKamgar"
        })
    },
    BlackListMukadam:function(Mukadam){
        dispatcher.dispatch({
            Mukadam:Mukadam,
            type:"KamgarInfo:BlackListMukadam"
        })
    },
    BlackListKamgar:function(Workar){
        dispatcher.dispatch({
            Workar:Workar,
            type:"KamgarInfo:BlackListKamgar"
        })
    },
}





// WEBPACK FOOTER //
// ./src/actions/UsTodniKamkarAction.js